import { Component, inject, model } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AnalysisExportStatus } from '@api-types/enums/analysis-export-status.enum';
import { PmIconComponent } from '@libs/ui';
import { DateUtilsService } from '@core/utils/date-utils.service';
import { TranslateModule } from '@ngx-translate/core';
import { AnalysisStateService } from 'demand-forecasting/analysis/services/analysis-state.service';
import { LucideLoaderCircle, LucideXCircle } from '@lucide/angular';

@Component({
  selector: 'pm-export-list-tab',
  templateUrl: './export-list-tab.component.html',
  imports: [
    TranslateModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    PmIconComponent,
  ],
})
export class ExportListTabComponent {
  protected readonly analysisStateService = inject(AnalysisStateService);
  protected readonly AnalysisExportStatus = AnalysisExportStatus;
  protected readonly dateUtilsService = inject(DateUtilsService);

  protected readonly loaderIcon = LucideLoaderCircle;
  protected readonly errorIcon = LucideXCircle;

  selectedExportId = model<string | undefined>();
}
